/**
 * Alaska: App.js (PWA)
 * @version 1.0
 */

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";

Alpine.plugin(intersect);
window.Alpine = Alpine;

// ---- App ---- //
// Components
import "./components/schedule.js";
import "./components/account.js";
import "./components/auth.js";
import "./components/editor.js";
import "./components/job.js";
import "./components/splash.js";
import "./components/documents.js";
import "./components/upload.js";

// Stores
import "./stores/documents.js";
import "./stores/modal.js";
import "./stores/navigation.js";
import "./stores/overlay.js";
import "./stores/state.js";
import "./stores/user.js";

document.addEventListener("alpine:init", () => {
    Debug.enable();
});

Alpine.start();